<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.type"
              clearable
              placeholder="请选择物资类型"
              style="width:100%"
            >
              <el-option
                label="物料"
                :value="1"
              />
              <el-option
                label="样品烟"
                :value="2"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.materialCode"
              placeholder="请输入物料编码"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.materialName"
              placeholder="请输入物料名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px; padding: 0 2px;"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @batchImport="batchImportFun"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 批量导入数据 组件 -->
    <import-dialog
      :dialog-visible.sync="dialogImportVisible"
      :dialog-title="dialogImportTitle"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 查看
import viewDialog from './components/viewDialog'
// 批量导入数据 组件
import importDialog from './components/importDialog'
// API
import { loadPhysicalResourcesClaimFormListDataApi, exportPhysicalResourcesClaimFormListDataApi } from '@/api/v2/physicalResourcesClaimForm';

export default {
  name: 'PhysicalResourcesClaimFormView',
  components: {
    CustomTable2,
    TableOperation2,
    viewDialog,
    importDialog,
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'physical_resources_claim_form_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['physical_resources_claim_import'],
            prop: 'batchImport',
            label: '导入',
            method: 'batchImport'
          },
          {
            permissionSigns: ['physical_resources_claim_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['physical_resources_claim_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeNo: '',
          type: '',
          materialCode: '',
          materialName: '',
        }
      },
      id: null,
      eventType: '',
      // 查看
      dialogViewTitle: '查看',
      dialogViewVisible: false,
      // 批量导入
      dialogImportVisible: false,
      dialogImportTitle: '导入中烟实物资源领用单数据',
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'claimFormNo', label: '领用单编号', filterColumn: 'claim_form_no', width: 140 },
      { prop: 'applyTime', label: '申报日期', filterColumn: 'apply_time', width: 150, isBetween: true },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'scheme_no', width: 190 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'scheme_name', width: 240 },
      { prop: 'activityScenario', label: '活动场景', filterColumn: 'activity_scenario', width: 110 },
      { prop: 'purpose', label: '使用用途', filterColumn: 'purpose', width: 110 },
      { prop: 'typeValue', label: '物资类型', filterColumn: "(case type when 1 then '物料' when 2 then '样品烟' else '' end)", width: 110 },
      { prop: 'materialCode', label: '物料编码', filterColumn: 'material_code', width: 110 },
      { prop: 'materialName', label: '物料名称', filterColumn: 'material_name', width: 200 },
      { prop: 'schemeNumber', label: '方案数量', filterColumn: 'scheme_number', width: 110 },
      { prop: 'applyNumber', label: '本次申领数量', filterColumn: 'apply_number', width: 125 },
      { prop: 'price', label: '单价', filterColumn: 'price', width: 90 },
      { prop: 'amount', label: '金额', filterColumn: 'amount', width: 100 },
      { prop: 'receiveDepartment', label: '领用部门', filterColumn: 'receive_department', width: 110 },
      { prop: 'receiver', label: '领用人', filterColumn: 'receiver', width: 90 },
      { prop: 'auditor', label: '审核人', filterColumn: 'auditor', width: 90 },
      { prop: 'auditTime', label: '审核时间', filterColumn: 'audit_time', width: 150, isBetween: true },
      { prop: 'outboundOperator', label: '出库人', filterColumn: 'outbound_operator', width: 90 },
      { prop: 'outboundTime', label: '出库时间', filterColumn: 'outbound_time', width: 150, isBetween: true },
      { prop: 'outboundNo', label: '领用出库单编号', filterColumn: 'outbound_no', width: 160 },
      { prop: 'creatorName', label: '创建人', filterColumn: 'creator_name', width: 100 },
      { prop: 'createTime', label: '创建时间', filterColumn: 'create_time', width: 150, isBetween: true },
      { prop: 'operatorName', label: '操作人', filterColumn: 'operator_name', width: 100 },
      { prop: 'operationTime', label: '操作时间', filterColumn: 'operation_time', width: 150, isBetween: true },
    ]

    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadPhysicalResourcesClaimFormListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response;
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 批量导入
    batchImportFun () {
      let _this = this;
      _this.dialogImportVisible = !_this.dialogImportVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的中烟实物资源领用单数据', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportPhysicalResourcesClaimFormListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
